import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ToastContainer, Slide } from "react-toastify";
import "./App.css";
import CustomNavbar from "./components/Navbar";
import Home from "./pages/Home";
import IGA from "./pages/IdentityGovernanceAndAdministration";
import AccessManagement from "./pages/AccessManagement";
import MFA from "./pages/MultiFactorAuthentication";
import PriviledgeAcessManagement from "./pages/PriviledgeAcessManagement";
import IAMImplementationServices from "./pages/IAMImplementationServices";
import IAMAdvisoryServices from "./pages/IAMAdvisoryServices";
import IAMManagedServices from "./pages/IAMManagedServices";
import ContactUs from "./pages/ContactUs";

function App() {
  return (
    <div>
      <BrowserRouter>
        <CustomNavbar />
        <ToastContainer
          position="top-right"
          autoClose={2000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
          transition={Slide}
        />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/id&a" element={<IGA />} />
          <Route path="/access-m" element={<AccessManagement />} />
          <Route path="/m-fa" element={<MFA />} />
          <Route path="/pam" element={<PriviledgeAcessManagement />} />
          <Route path="/iam-imp" element={<IAMImplementationServices />} />
          <Route path="/iam-adv" element={<IAMAdvisoryServices />} />
          <Route path="/iam-man" element={<IAMManagedServices />} />
          <Route path="/contact" element={<ContactUs />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
